import { render, staticRenderFns } from "./FormControlProductTypesShipping.vue?vue&type=template&id=6d415710&scoped=true"
import script from "./FormControlProductTypesShipping.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlProductTypesShipping.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlProductTypesShipping.vue?vue&type=style&index=0&id=6d415710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d415710",
  null
  
)

export default component.exports